import axios from "axios";
import { jwtDecode } from "jwt-decode";
import config from "./Config";

const redirectToLogin = () => {
  window.location.assign("/");
};

export const dfdInstance = axios.create({
  baseURL: config.dfdUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const leInstance = axios.create({
  baseURL: config.leUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const tiInstance = axios.create({
  baseURL: config.tiUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const crcInstance = axios.create({
  baseURL: config.crcUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const refInstance = axios.create({
  baseURL: config.refProdUrl,
  // baseURL: config.refTestUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const authInstance = axios.create({
  baseURL: config.authUrl,
});

export const forfaitInstance = axios.create({
  baseURL: config.forfaitUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

const configuration = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      localStorage.removeItem("token");

      redirectToLogin();
    } else {
      const header = "Bearer " + token;
      config.headers.Authorization = header;
    }
  } else {
    localStorage.removeItem("token");
    localStorage.removeItem("suspend");
    localStorage.removeItem("valide");
    redirectToLogin();
  }

  return config;
};

dfdInstance.interceptors.request.use((config) => configuration(config));
leInstance.interceptors.request.use((config) => configuration(config));
tiInstance.interceptors.request.use((config) => configuration(config));
refInstance.interceptors.request.use((config) => configuration(config));
crcInstance.interceptors.request.use((config) => configuration(config));